/** Opt-in local testing must never silently fall back to a live Firebase project. */
function localTestConfig({ enabled, projectId, authHost, firestoreHost } = {}) {
  if (enabled !== '1') return null;
  const loopback = /^(127\.0\.0\.1|localhost):([1-9][0-9]{0,4})$/;
  if (projectId !== 'demo-cfamockexam') throw new Error('Local testing requires demo-cfamockexam.');
  for (const host of [authHost, firestoreHost]) {
    if (!loopback.test(host || '') || Number(host.split(':')[1]) > 65535) {
      throw new Error('Local testing requires explicit loopback emulator hosts.');
    }
  }
  return { projectId, authHost, firestoreHost };
}
module.exports = { localTestConfig };
